module.exports = __webpack_public_path__ + "img/wcyg-experience.4a295fa0.svg";